export const BRANDBAR_HEIGHT = '96px';
export const BRANDBAR_HEIGHT_PX = '96';
